import "core-js/modules/es.string.link.js";
import "core-js/modules/es.string.bold.js";
import React from 'react';
import { NavLink } from 'react-router-dom';
import TextLink from 'components/TextLink';
import { useAppNameContext } from 'hooks/useAppNameContext';
export function AdminOrHubTextLink(_ref) {
  var link = _ref.link,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    children = _ref.children;
  var appNameContext = useAppNameContext();
  if (appNameContext === 'hub') {
    return /*#__PURE__*/React.createElement(TextLink, {
      target: "_blank",
      as: "a",
      href: "/admin".concat(link),
      bold: bold
    }, children);
  } else {
    return /*#__PURE__*/React.createElement(TextLink, {
      as: NavLink,
      to: link,
      bold: bold
    }, children);
  }
}
export default AdminOrHubTextLink;